import React from "react";
import "./VendorCard.css";
import LocationSvg from "../svgs/LocationSvg";
import ClockSvg from "../svgs/ClockSvg";
import RatingSvg from "../svgs/RatingSvg";

interface VendorCardProps {
  image: string;
  name: string;
  location: string;
  deliveryTime: string;
  rating: number;
  reviews: number;
}

const VendorCard: React.FC<VendorCardProps> = ({
  image,
  name,
  location,
  deliveryTime,
  rating,
  reviews,
}) => {
  return (
    <div className="vendor-card">
      <img src={image} alt={name} className="vendor-card__image" />
      <div className="vendor-card__info">
        <h2 className="vendor-card__name">{name}</h2>
        <p className="vendor-card__details">
          <LocationSvg />
          {location} |
          <ClockSvg />
          {deliveryTime} <RatingSvg />
          {rating} ({reviews})
        </p>
        {/* <p className="vendor-card__rating">
          <RatingSvg />
          {rating} ({reviews})
        </p> */}
      </div>
    </div>
  );
};

export default VendorCard;
